function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgEc = function SvgEc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBC9A0"
    },
    d: "M471.997,247.999v55.999c0,4.422,3.578,8,8,8s8-3.578,8-8v-55.999L471.997,247.999L471.997,247.999z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.994,
    y: 247.996,
    style: {
      fill: "#D7B48C"
    },
    width: 16,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBC9A0"
    },
    d: "M32.003,200c-4.422,0-8,3.578-8,8v55.999h16V208C40.002,203.578,36.425,200,32.003,200z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 239.996,
    style: {
      fill: "#D7B48C"
    },
    width: 16,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M232,327.998v40c0,51.322-44.162,92.524-96.482,87.599c-45.594-4.292-79.516-44.38-79.516-90.176V264 c0-4.418-3.582-8-8-8h-32c-4.418,0-8,3.582-8,8v103.999c0,74.22,59.758,134.741,133.688,135.979 c76.062,1.273,138.309-63.508,138.308-139.58V328V184.002v-40c0-51.322,44.162-92.524,96.482-87.599 c45.594,4.292,79.516,44.38,79.516,90.176V248c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8V144.001 c0-74.22-59.758-134.741-133.688-135.979c-76.062-1.273-138.309,63.508-138.309,139.58v36.399v143.997H232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M362.585,32.13C302.345,34.966,256,86.857,256,147.163V160c0,4.418-3.582,8-8,8h-16v175.998h16 c4.418,0,8,3.582,8,8v12.837c0,60.306-46.345,112.198-106.585,115.034c-64.316,3.029-117.413-48.22-117.413-111.871V255.999h-16 c-4.418,0-8,3.582-8,8v103.999c0,74.219,59.758,134.741,133.688,135.978C217.753,505.249,280,440.468,280,364.396v-36.398V184v-40 c0-51.322,44.162-92.524,96.481-87.599c45.594,4.292,79.517,44.38,79.517,90.177v101.421c0,4.418,3.582,8,8,8h16V144 C479.997,80.35,426.901,29.101,362.585,32.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M311.999,327.998H200.001c-8.837,0-16-7.163-16-16V200c0-8.837,7.163-16,16-16h111.999 c8.837,0,16,7.163,16,16v111.999C327.999,320.835,320.836,327.998,311.999,327.998z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF082"
    },
    d: "M16.011,192c-2.938,0-5.758-1.617-7.164-4.422l-8-16c-1.977-3.953-0.375-8.758,3.578-10.734 c3.953-1.969,8.758-0.375,10.734,3.578l8,16c1.977,3.953,0.375,8.758-3.578,10.734C18.433,191.727,17.214,192,16.011,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF082"
    },
    d: "M47.994,192c-1.203,0-2.422-0.273-3.57-0.844c-3.953-1.977-5.555-6.781-3.578-10.734l8-16 c1.984-3.953,6.781-5.547,10.734-3.578c3.953,1.977,5.555,6.781,3.578,10.734l-8,16C53.752,190.383,50.932,192,47.994,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF082"
    },
    d: "M504.005,351.998c-2.938,0-5.758-1.617-7.164-4.422l-8-16c-1.977-3.953-0.375-8.758,3.578-10.734 c3.953-1.961,8.758-0.375,10.734,3.578l8,16c1.977,3.953,0.375,8.758-3.578,10.734 C506.427,351.725,505.208,351.998,504.005,351.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF082"
    },
    d: "M455.99,351.998c-1.203,0-2.422-0.273-3.57-0.844c-3.953-1.977-5.555-6.781-3.578-10.734l8-16 c1.977-3.953,6.781-5.539,10.734-3.578c3.953,1.977,5.555,6.781,3.578,10.734l-8,16 C461.748,350.381,458.928,351.998,455.99,351.998z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M264,295.999c-26.51,0-47.999-21.49-47.999-47.999V184h-16c-8.837,0-16,7.163-16,16v111.999 c0,8.837,7.163,16,16,16h111.999c8.837,0,16-7.163,16-16v-16H264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M256,303.998c-0.992,0-2-0.18-2.969-0.57c-4.102-1.641-6.102-6.297-4.461-10.398L260.187,264h-20.188 c-2.656,0-5.133-1.32-6.625-3.516c-1.484-2.195-1.789-4.992-0.805-7.453l16-40c1.641-4.117,6.336-6.109,10.398-4.461 c4.102,1.641,6.102,6.297,4.461,10.398l-11.617,29.031h20.188c2.656,0,5.133,1.32,6.625,3.516c1.484,2.195,1.789,4.992,0.805,7.453 l-16,40C262.18,302.1,259.172,303.998,256,303.998z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ec.6d1d6137.svg";
export { ForwardRef as ReactComponent };